export const ASSESSMENT_PAGE_LABELS = {
  addAssessmentButton: 'Add assessment',
  drawerTitle: undefined, // TODO: Udi need to decide on the title for the drawer
  pickerTitle: 'Which third-party do you want to assess?',
  pickerPlaceholder: 'Search your third-parties, or add a new one',
  newAssessmentModalTitle: 'New assessment',
  assessmentDetails: 'Assessment details',
} as const

export const NO_RESPONSE_LABEL = 'No Response'

export const VENDOR_COMMENT_FILTER = {
  header: 'Vendor comment',
  hasComments: 'Has comments',
  noComments: 'No comments',
} as const
